import Schema from './Schema'
import { organizationSchema } from './Schema.util'

const LogoSchema = (): React.ReactElement => {
  const schemaObject = {
    '@context': 'https://schema.org',
    ...organizationSchema,
  }
  return <Schema schemaObject={schemaObject} />
}

export default LogoSchema
